import { TransformInitOptions } from '../../../../middleware';
import { AppState } from '../../../app.types';
import { RESPONSE_ERROR_CODES } from '@api';
import {
    isDefined, isNonEmptyString
} from '@utils';

/**
 * A common way to add the required 3p auth headers from app state,
 * to a fetch api's RequestInit options.
 */
export function addAuthHeaders ({
    init,
    state,
    dispatch
}: TransformInitOptions<AppState>) {
    const authData: Record<string, unknown> = state?.auth?.data || {};
    // Add either legacy or jwt tokens to header
    const authHeaders: Record<string, string> = {
        ...isNonEmptyString(authData.token) && { authtoken: authData.token },
        ...isNonEmptyString(authData.jwtToken) && { authorization: `Bearer ${authData.jwtToken}` }
    };

    // If there is neither types of tokens we need to handle this error in the application state
    if (!isDefined(authHeaders['authorization']) && !isDefined(authHeaders['authtoken'])) {
        dispatch({
            type: RESPONSE_ERROR_CODES.Type,
            payload: { code: RESPONSE_ERROR_CODES.MissingToken }
        });
    }

    return {
        ...init.headers || {},
        ...authHeaders
    };
}
